export const buildCustomerBookingRequest = ({
  date,
  assignments,
  detailsFromCustomer,
  selectedMembershipPlanId,
  selectedPlanMembership,
  selectedMembershipId,
  selectedPackagePaymentId,
  bookingProductLines,
  payingOnline,
  payInFull,
  policyAccepted,
  policyLanguage,
  consentAcceptanceBatchId,
}) => {
  const membershipId = selectedMembershipPlanId
    ? selectedPlanMembership?.id
    : selectedMembershipId;

  return {
    date,
    serviceAssignments: assignments,
    detailsFromCustomer: detailsFromCustomer?.trim() || undefined,
    customerMembershipIds: membershipId ? [membershipId] : undefined,
    membershipPlanId: selectedMembershipPlanId && !selectedPlanMembership
      ? selectedMembershipPlanId
      : undefined,
    customerServicePackageId: selectedPackagePaymentId || undefined,
    products: bookingProductLines?.length ? bookingProductLines : undefined,
    payOnline: Boolean(payingOnline),
    payFullAmountOnline: Boolean(payingOnline && payInFull),
    acceptedCancellationPolicy: Boolean(payingOnline && policyAccepted),
    policyLanguage: payingOnline ? policyLanguage : undefined,
    consentAcceptanceBatchId: consentAcceptanceBatchId || undefined,
  };
};

export const customerBookingPaysOnline = ({
  nothingToPay,
  hasUnpricedSelection,
  selectedPaymentMethod,
  prepaymentRequired,
  appointmentAllowsOnline,
  usesEntitlement,
}) => !nothingToPay && !hasUnpricedSelection && (
  selectedPaymentMethod === 'online'
  || (Boolean(usesEntitlement) && prepaymentRequired && appointmentAllowsOnline)
);

export const resolveBookingConfirmResult = (response, { payingOnline } = {}) => {
  if (response?.awaitingConfirmation) {
    return { type: 'awaitingConfirmation' };
  }

  if (response?.coveredByMembership) {
    return { type: 'membership' };
  }

  if (response?.coveredByServicePackage) {
    return { type: 'package' };
  }

  if (payingOnline && response?.requiresOnlinePayment && response?.appointmentId) {
    return { type: 'checkout', appointmentId: response.appointmentId };
  }

  return { type: 'success' };
};

export const resolveBookingPaymentOutcome = ({ outcome, bookingReleased } = {}) => {
  if (outcome === 'Paid') {
    return { type: 'paid' };
  }

  if (bookingReleased || outcome === 'Failed' || outcome === 'Expired') {
    return { type: 'failed' };
  }

  return { type: 'processing' };
};
